module.exports = __webpack_public_path__ + "static/media/ic-trash-active.c721ec70.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic-trash-active.svg
// module id = 658
// module chunks = 0